import { useTranslation } from 'react-i18next';
import { formatter } from '@repo/shared';
import type { ColumnDef } from '@tanstack/react-table';

import type { DatasetsQueryResult } from '@/api/generated';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';
import { ExpandableRow } from '@/components/blocks/data-table/expandable-row';

export const columns: Array<ColumnDef<DatasetsQueryResult['data'][number]>> = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.table.name')}
        />
      );
    },
    enableSorting: false,
  },
  {
    accessorKey: '_count.files',
    header: ({ column }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.table.amountOfFiles')}
        />
      );
    },
    enableSorting: false,
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.table.createdAt')}
        />
      );
    },
    cell: ({ row }) =>
      formatter.date.dateTime(new Date(row.original.createdAt as string)),
  },
  {
    id: 'expandable',
    accessorFn: (row) => row._count.files,
    header: () => null,
    cell: ({ row }) => <ExpandableRow row={row} />,
  },
];
